var _rect, _path, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBench(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    stroke: "#262626",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5825,
    y: 24.7119,
    width: 76.8333,
    height: 16.949,
    rx: 3,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.371 56.144C13.5456 55.8205 13.8835 55.6189 14.2511 55.6189H91.7493C92.1168 55.6189 92.4547 55.8205 92.6293 56.144L99.6208 69.0989C99.9804 69.7652 99.4979 70.5738 98.7408 70.5738H7.25952C6.50242 70.5738 6.01992 69.7652 6.37949 69.0989L13.371 56.144Z",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.167,
    y1: 70.5737,
    x2: 12.167,
    y2: 90.5137,
    strokeWidth: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.5825,
    y1: 42.658,
    x2: 24.5825,
    y2: 56.6159,
    strokeWidth: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 81.417,
    y1: 42.658,
    x2: 81.417,
    y2: 56.6159,
    strokeWidth: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24.5825,
    y1: 20.7358,
    x2: 24.5825,
    y2: 22.7058,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81.417,
    y1: 20.7358,
    x2: 81.417,
    y2: 22.7058,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 93.8345,
    y1: 70.5737,
    x2: 93.8345,
    y2: 90.5137,
    strokeWidth: 8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBench);
export default __webpack_public_path__ + "static/media/ico-bench.a0e0490b.svg";
export { ForwardRef as ReactComponent };